"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSelect = _interopRequireWildcard(require("react-select"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _searchableListModule = _interopRequireDefault(require("./searchableList.module.css"));

var _arrowRightIcon = _interopRequireDefault(require("../icons/arrowRightIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reactSelectCustomStyles = {
  control: function control(provided, state) {
    return _objectSpread({}, provided, {
      border: '1px solid #d8d8d8',
      borderRadius: '0px',
      boxShadow: '0 1px 3px #d8d8d8 inset',
      '&:hover': {
        border: '1px solid #d8d8d8'
      },
      minHeight: 36,
      background: state.isDisabled ? 'rgba(169,169,169,0.1)' : 'inherit',
      pointerEvents: state.isDisabled ? 'auto' : 'default',
      cursor: state.isDisabled ? 'not-allowed' : 'default'
    });
  },
  container: function container(base) {
    return _objectSpread({}, base, {
      minHeight: 34
    });
  },
  placeholder: function placeholder(base, state) {
    return _objectSpread({}, base, {
      fontWeight: 'normal',
      color: state.isDisabled ? 'rgba(169,169,169,1)' : '#000',
      fontFamily: "Arial, sans-serif",
      fontSize: "15px"
    });
  },
  loadingIndicator: function loadingIndicator(base) {
    return _objectSpread({}, base, {
      marginRight: '18px'
    });
  },
  dropdownIndicator: function dropdownIndicator(base) {
    return _objectSpread({}, base);
  },
  clearIndicator: function clearIndicator(base) {
    return _objectSpread({}, base, {
      paddingTop: 0,
      paddingBottom: 0,
      color: "#000",
      marginRight: '28px',
      position: "absolute",
      top: 8,
      right: 0
    });
  },
  indicatorsContainer: function indicatorsContainer(base) {
    return _objectSpread({}, base, {
      display: 'flex',
      alignItems: "center"
    });
  },
  indicatorSeparator: function indicatorSeparator(base) {
    return {
      display: 'none'
    };
  },
  input: function input(base) {
    return _objectSpread({}, base, {
      margin: 0,
      padding: 0,
      fontFamily: 'arial, sans-serif',
      color: 'black',
      input: {
        opacity: "1 !important",
        '&:disabled': {
          color: '#808080  !important'
        }
      }
    });
  },
  menu: function menu(provided, state) {
    return _objectSpread({}, provided, {
      zIndex: 3
    });
  },
  option: function option(base) {
    return _objectSpread({}, base, {
      fontFamily: 'arial, sans-serif',
      color: 'black',
      fontSize: '1em; color: #000'
    });
  }
};

var DropdownIndicator = function DropdownIndicator(props) {
  return _react.default.createElement(_reactSelect.components.DropdownIndicator, props, _react.default.createElement("button", {
    className: (0, _classnames.default)(_searchableListModule.default["btn"], _searchableListModule.default["form-control"], _searchableListModule.default["buttonPicker"]),
    tabIndex: -1
  }, _react.default.createElement(_arrowRightIcon.default, {
    className: _searchableListModule.default["icon-arrow"]
  })));
};

var NoOptionsMessage = function NoOptionsMessage(props) {
  var msg = props.selectProps.noOptionsText ? props.selectProps.noOptionsText : 'No Options';

  if (props.selectProps.minSearchCharacters !== undefined && props.selectProps.inputValue.length < props.selectProps.minSearchCharacters || props.selectProps.isLoading) {
    msg = '';
  }

  return _react.default.createElement(_reactSelect.components.NoOptionsMessage, props, _react.default.createElement("span", null, msg));
};

var valueFromIds = function valueFromIds(opts, value) {
  return opts.find(function (o) {
    return o.value === value.value;
  });
};

var valuesFromIds = function valuesFromIds(opts, values) {
  return values.map(function (value) {
    return opts.find(function (o) {
      return o.value === value.value;
    });
  });
};

var SearchableList = function SearchableList(props) {
  var options = props.options,
      onChange = props.onChange,
      value = props.value,
      isLoading = props.isLoading,
      instanceId = props.instanceId,
      isDisabled = props.isDisabled,
      onInputChange = props.onInputChange,
      onBlur = props.onBlur,
      autoComplete = props.autoComplete,
      inputValue = props.inputValue,
      placeholder = props.placeholder,
      noOptionsText = props.noOptionsText,
      minSearchCharacters = props.minSearchCharacters,
      isMulti = props.isMulti;
  var isMultiple = isMulti ? isMulti : false;
  var mappedValue = value;
  var placeholderText = placeholder ? placeholder : 'Select...'; //get the label that corresponds to the selected value ids of the option items

  try {
    mappedValue = isMultiple ? valuesFromIds(options, value) : valueFromIds(options, value);
  } catch (e) {
    mappedValue = null;
  }

  if (mappedValue === undefined) {
    mappedValue = null;
  }

  return _react.default.createElement(_reactSelect.default, {
    inputProps: {
      autoComplete: autoComplete ? autoComplete : ""
    },
    inputValue: inputValue,
    instanceId: instanceId,
    components: {
      DropdownIndicator: DropdownIndicator,
      NoOptionsMessage: NoOptionsMessage
    },
    styles: reactSelectCustomStyles,
    onChange: onChange,
    onInputChange: onInputChange,
    options: options,
    value: mappedValue,
    noOptionsText: noOptionsText,
    isLoading: isLoading,
    isDisabled: isDisabled,
    onBlur: onBlur,
    isMulti: isMultiple,
    placeholder: placeholderText,
    minSearchCharacters: minSearchCharacters
  });
};

SearchableList.propTypes = {
  /** An array with the options as objects. Every object - option must contain a value and label property.
   * {value: 4, label: "First item"}. You can also choose to pass any other property to the option object you want */
  options: _propTypes.default.array.isRequired,

  /** Callback invoked when the selected items change. It will be passed the new selectedItems as the first argument
   * eg: (values) => {} */
  onChange: _propTypes.default.func.isRequired,

  /** String text that enables or disable the browser to offer autocompletion */
  autoComplete: _propTypes.default.string,

  /** Callback invoked when the input is change.*/
  onInputChange: _propTypes.default.func,

  /** An array that must contain all the selected options with their value properties (they are used as keys) */
  value: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]),

  /** Prop used to control the typed input */
  inputValue: _propTypes.default.any,

  /** Boolean indicating if the multi select is loading the options */
  isLoading: _propTypes.default.bool,

  /** String that can be anything unique */
  instanceId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,

  /** Boolean indicating if the input is disabled or not */
  isDisabled: _propTypes.default.bool,

  /** Callback invoked on blur. An event argument will be available. eg: (evt) => {} */
  onBlur: _propTypes.default.func,

  /** boolean for allowing multiple selection */
  isMulti: _propTypes.default.bool,

  /** text to display when nothing is selected */
  placeholder: _propTypes.default.string,

  /** text to display when no options are available in the dropdown after searching */
  noOptionsText: _propTypes.default.string,

  /** number of characters before start filtering the list */
  minSearchCharacters: _propTypes.default.number
};
var _default = SearchableList;
exports.default = _default;